import React from 'react';

import {
    getMeta,
    getPropertyKeysBySection,
    isPropertyAvailable,
    sections,
} from '../../../lib/playerPreferenceMeta';
import PreferenceInput from './PreferenceInput';
import ThemeTab from './ThemeTab';

/**
 * Renders one section's inputs. Replaces the v3 lib/PreferenceTabWrapper
 * for the player path (lib variant left untouched -- still consumed by
 * the listing editor). Derives the property list from the metaMap SDK
 * instead of walking a nested `preference[section].preferences` tree.
 */
export default function PreferenceTabWrapper (props) {
    const { sectionKey, merged, storeEdits, assets, peerStatus } = props;

    // Theme owns its own layout: the 48 tokens are one visual decision,
    // so they render as a tiered control rail against a live preview
    // rather than as a flat list, and the editor re-proportions around
    // them (see `PlayerPreferenceEditor`'s theme mode). It still sources
    // labels and inputs from the metaMap.
    if (sectionKey === 'theme') {
        return <ThemeTab {...props}/>;
    }

    const section = sections.find(s => s.key === sectionKey);
    const keys = getPropertyKeysBySection(sectionKey);
    const capabilities = { isP2pEnabled: peerStatus && peerStatus.enabled };

    return (
        <div id="tab">
            <header>
                <h2>{section ? section.displayName : ''}</h2>
                {section && section.description ? <em>{section.description}</em> : null}
            </header>
            <hr/>
            <section>
                {keys.map(key => {
                    if (!isPropertyAvailable(key, capabilities)) return null;
                    const meta = getMeta(key);
                    if (meta.hidden) return null;
                    return (
                        <div key={key} className="preference">
                            <div>
                                <h4>{meta.displayName}</h4>
                                <p>{meta.description}</p>
                                <div>
                                    <PreferenceInput
                                        propertyKey={key}
                                        meta={meta}
                                        value={merged[key]}
                                        onChange={storeEdits}
                                        assets={assets}
                                    />
                                </div>
                            </div>
                            <hr/>
                        </div>
                    );
                })}
            </section>
        </div>
    );
}
